const localStorageKeys = {
	TOKEN_KEY: "@maestro-web:token",
	LOGGED_USER: "maestro-logged-user"
};

export default localStorageKeys;
